import api from "./core";

const basePath = "api/core/Patients";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  uploadAvatar(data) {
    const { file, clientId } = data;
    const formData = new FormData();
    formData.append("File", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.put(`${basePath}/UploadAvatar/${clientId}`, formData, config);
  },
  viewAvatarUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/UploadDownload/${api.getToken()}/${id}`;
  },
  getSSN(id) {
    return api.get(`${basePath}/Ssn/${id}`);
  },
  getNextMrn() {
    return api.get(`${basePath}/GetNextMrn`);
  },
  syncDoseSpot(id) {
    return api.patch(`${basePath}/${id}/SyncDoseSpot`);
  },
  syncPracticeSuite(id) {
    return api.patch(`${basePath}/${id}/SyncPracticeSuite`);
  },
  getFromAllLocations(filter, extraHeaders = {}) {
    return api.post(`${basePath}/GetFromAllLocations`, filter, extraHeaders);
  },
  findPosibleDuplications(data, extraHeaders = {}) {
    return api.post(`${basePath}/FindPosibleDuplications`, data, extraHeaders);
  }
};
